import { Box, Flex, Text } from "@storyofams/react-ui";

export const Usage = ({ howToUse }) => {
  return (
    <Box>
      <Text
        display={["none", "block"]}
        fontFamily={"DINPro"}
        fontWeight={700}
        fontSize={"24px"}
        mb={[0, 2]}
      >
        {"Gebruik"}
      </Text>
      <Text
        fontSize={["16px", "18px"]}
        color="#1D1D1BCC"
        lineHeight={"25.2px"}
        maxWidth={["none", "800px"]}
        mb={[0, "20px"]}
        dangerouslySetInnerHTML={{
          __html: howToUse,
        }}
      />
    </Box>
  );
};
